import { StylesOptions } from '@material-ui/styles/';

export const GenerateClassName: StylesOptions['generateClassName'] = (
  rule,
  sheet
): string => {
  return `${sheet!.options.classNamePrefix}-${rule.key}`;
};
